import { useTranslation } from "react-i18next"

import type { PersonaOnboardingReviewItem } from "../../types/personas.types"
import { MetricTile } from "./MetricTile"

export function IndustryMetricGrid({
  persona,
  sharePct,
}: {
  persona: PersonaOnboardingReviewItem["persona"]
  sharePct: number | null
}) {
  const { t } = useTranslation()
  return (
    <div className="grid shrink-0 grid-cols-2 gap-[7px]">
      <MetricTile
        value={
          sharePct != null
            ? t("personas.onboarding.industry.marketPresenceValue", {
                defaultValue: "{{pct}}%",
                pct: Number(sharePct.toFixed(1)),
              })
            : t("personas.onboarding.industry.metricEmpty", "—")
        }
        label={t("personas.onboarding.industry.marketPresenceLabel", "market presence")}
        valueClassName="text-[var(--competitor)]"
      />
      <MetricTile
        value={
          persona.adCount > 0
            ? persona.adCount.toLocaleString()
            : t("personas.onboarding.industry.metricEmpty", "—")
        }
        label={t("personas.onboarding.industry.adsLabel", "ads")}
      />
      <MetricTile
        value={
          persona.competitorCount != null && persona.competitorCount > 0
            ? persona.competitorCount.toLocaleString()
            : t("personas.onboarding.industry.metricEmpty", "—")
        }
        label={t("personas.onboarding.industry.brandsLabel", "brands")}
        muted={persona.competitorCount == null || persona.competitorCount <= 0}
      />
      <MetricTile
        value={
          persona.avgDays != null
            ? t("personas.onboarding.industry.avgDaysValue", {
                defaultValue: "{{days}}d",
                days: Math.round(persona.avgDays),
              })
            : t("personas.onboarding.industry.metricEmpty", "—")
        }
        label={t("personas.onboarding.industry.avgDaysLabel", "avg days live")}
        muted={persona.avgDays == null}
      />
    </div>
  )
}
